export const workEmailRequiredMessage = 'Please use your company email address.';
export const workEmailRequiredTransportMessage = 'Please use your company email address';
export const competitorReportRequestRetryableErrorMessage =
  'We couldn’t send your request. Please try again.';
